__turbopack_context__.v({
  "button": "HSZyWW_button",
  "jobPreviewButtonDesktop": "HSZyWW_jobPreviewButtonDesktop",
  "jobPreviewButtonMobile": "HSZyWW_jobPreviewButtonMobile",
  "jobPreviewContainer": "HSZyWW_jobPreviewContainer",
  "jobPreviewContainerMobile": "HSZyWW_jobPreviewContainerMobile",
});
